import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrInfo } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrInfo = (info?: PqrInfo) => {
    const formik = useFormik({
        initialValues: {
            status: '',
            country: '',
            location: '',
            correspondenceFiling: '',
            detail: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            status: useGetNameOrValue(info?.status || ''),
            country: useGetNameOrValue(info?.country || ''),
            location: useGetNameOrValue(info?.location || ''),
            correspondenceFiling: info?.correspondenceFiling || '',
            detail: info?.detail || '',
        });
    }, [info]);

    return {
        formik,
    };
};
